import 'components/catalog.tag'
riot.tag2('comments-list', '  <catalog search="true" sortable="true" object="Comment" cols="{cols}" reload="true" add="{permission(add, &quot;comments&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;comments&quot;, &quot;0001&quot;)}" dblclick="{permission(commentOpen, &quot;comments&quot;, &quot;1000&quot;)}" store="comments-list">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="date">{row.date}</datatable-cell>\n      <datatable-cell name="nameProduct">{row.nameProduct}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="email">{row.email}</datatable-cell>\n      <datatable-cell name="commentary">{row.commentary}</datatable-cell>\n      <datatable-cell name="response">{row.response}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.collection = 'Comment';

self.mixin('permissions');
self.mixin('remove');

self.add = function () {
    riot.route('/reviews/comments/new');
};

self.cols = [{ name: 'id', value: '#' }, { name: 'date', value: 'Дата' }, { name: 'nameProduct', value: 'Наименование товара' }, { name: 'name', value: 'Пользователь' }, { name: 'email', value: 'E-mail' }, { name: 'commentary', value: 'Комментарий' }, { name: 'response', value: 'Ответ' }];

self.commentOpen = function (e) {
    riot.route('/reviews/comments/' + e.item.row.id);
};

observable.on('comments-reload', function () {
    self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/comments/comments-list.tag